'use strict'
module.exports = require('./lib')(require('./lib/elliptic'))



//////////////////
// WEBPACK FOOTER
// ./~/secp256k1/elliptic.js
// module id = 1740
// module chunks = 0 1 2